<template>
  <div class="_contentContainer">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item >检测信息</el-breadcrumb-item>
      <el-breadcrumb-item>预约阶段</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <el-divider></el-divider> -->
    <header>
      <h3>客户信息</h3>
    </header>
    <el-form
      :inline="true"
      :model="query"
      class="demo-form-inline"
      label-position="top"
    >
      <el-row>
        <el-col :span="6">
          <el-form-item label="手机号码">
            <el-input v-model="query.teleNum" placeholder="手机号码"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="姓名">
            <el-input v-model="query.name" placeholder="姓名"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="检测日期">
            <el-date-picker
              v-model="query.date"
              placeholder="检测日期"
            ></el-date-picker>
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item label="检测状态">
            <el-select v-model="query.state"  clearable placeholder="请选择检测状态">
              <el-option v-for="(item,index) in stateList" 
                :label="item.label" 
                :value="item.value" 
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" :offset="18">
          <el-form-item>
            <el-button type="primary" size="medium" @click="search"
              >查询</el-button
            >
            <!-- <el-button type="primary" size="medium" @click="print"
              >打印</el-button
            > -->
            <el-button type="primary" size="medium" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      v-loading = "pictLoading"
      element-loading-background = "rgba(0, 0, 0, 0.2)"
      element-loading-text = "数据正在加载中"
      element-loading-spinner = "el-icon-loading"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      fit
      highlight-current-row
      style="width: 100%"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="userTeleNum" label="手机号码"></el-table-column>
      <el-table-column prop="name" label="姓名"> </el-table-column>
      <el-table-column prop="gender" label="性别"> </el-table-column>
      <el-table-column prop="age" label="年龄" :formatter="ageFormatter">
      </el-table-column>
      <el-table-column prop="bookedTime" label="预约时间"> </el-table-column>
      <el-table-column
        prop="state"
        label="检测状态"
        :formatter="stateFormatter"
      ></el-table-column>
      <!-- <el-table-column prop="userExams.finishedTime" label="检测时间" width="150"></el-table-column> -->
      <!-- <el-table-column prop="feedbackStatus"         label="反馈状态" width="100"></el-table-column> -->
      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="HasArrived(scope.row)"
            >确认到达</el-button
          >
          <el-button size="mini" type="danger" @click="CancelBook(scope.row)"
            >取消预约</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="pagination.pageSizeList"
        :page-size="pagination.pageSize"
        :total="pagination.totalNumber"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
// import Moment from 'moment'
import { ExamStatesValue ,ExamStatesLabel, unifiedPagination } from "../../../utils/constants"
import { searchUser, cancelBookedResource } from "../../../api/userService";
import { updateExamState } from "../../../api/userExamService";
import { Util_updateExamState } from "../../../utils/util";
import {
  Formatter_examStatesFormatter,
  Formatter_ageFormatter,
} from "../../../utils/formatter";

export default {
  name: "nurse",
  components: {},
  data() {
    return {
      //table Loading
      pictLoading:true,
      //查询字段
      query:{
        teleNum:"",
        name:"",
        // date: "",
        state: "",
      },
      stateRange: {
        fromStat: ExamStatesValue.BOOKED_10,
        toStat: ExamStatesValue.BOOK_CONFIRM_15,
      },
      //检测状态列表
      stateList:[
        {
          value:ExamStatesValue.BOOKED_10,
          label:ExamStatesLabel.BOOK_CONFIRM_15
        }
      ],
      //检测人列表
      tableData: [],
      multipleSelection: [],
      pagination: unifiedPagination,
    };
  },
  methods: {
    stateFormatter(row) {
      return Formatter_examStatesFormatter(row.state);
    },
    ageFormatter(row) {
      return Formatter_ageFormatter(row.birthDate);
    },
    _searchUser(){
      //path parameters
      let params = this.pagination.pageNum + '/' + this.pagination.pageSize;
      //body parameters
      let data = {};
      if(this.query.teleNum != ""){
        data.teleNum = this.query.teleNum
      }
      if(this.query.name != ""){
        data.name = this.query.name
      }
      // if(this.query.date != ""){
      //   console.log( this.query.date )
      //   data.date = Moment(this.query.date).format("YYYY-MM-DD HH:MM:SS")
      // }
      //state
      if(this.query.state){
        data.fromStat = this.query.state
        data.toStat = this.query.state;
      }else{
        data.fromStat = this.stateRange.fromStat
        data.toStat = this.stateRange.toStat
      }

      console.log("query",data)

      searchUser( params , data )
      .then(res => {
        if(res.success) {
          //初始化分页
          this.pagination.pageNum = 1
          this.pagination.currentPage = 1
          this.pagination.totalNumber = res.totalNumber
          this.pagination.totalPage = res.totalPage
          //初始化表格数据
          this.tableData = res.data;
          
        }
        else{
          this.$message({ message: res.description, type:"error"})
        }
        //table Loading
          setTimeout(this.loadingSuccess,800);
      })
      .catch(e => {
        //table Loading
          setTimeout(this.loadingSuccess,800);
        alert(e)
      })
    },
    //table Loading
    loadingSuccess(){
      this.pictLoading = false
    },
    print() {},
    search() {
      this._searchUser();
    },
    reset() {
      this.query.teleNum = "";
      this.query.name = "";
      // this.query.date = "";
       this.query.state = "";
      this._searchUser();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pagination.pageSize = val;
      this._searchUser();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pagination.pageNum = val;
      this._searchUser();
    },
    //已到达
    HasArrived(row) {
      //如果已到达，则将其状态改为30:基础问询中
      let state = ExamStatesValue.ARRIVAL_20;
      Util_updateExamState(
        row.examUuid,
        state,
        updateExamState,
        this._searchUser,
        this.$message
      );
    },
    CancelBook(row) {
      cancelBookedResource(row.userTeleNum)
        .then((res) => {
          if (res.success) {
            this.$message({ message: res.description, type: "success" });
            this._searchUser();
          } else {
            this.$message({
              message: res.description,
              type: "error",
            });
          }

          if (res.error) {
            this.$message({
              message: res.error,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e,
            type: "error",
          });
        });
    },
  },
  mounted() {
    this._searchUser();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

div.block {
  margin-top: 25px;
}

header {
  margin-top: 30px;
}


/* div.block {
  box-sizing: border-box;
}
._contentContainer {
  box-sizing: border-box;
  height: 563px;
  overflow-y: scroll;
} */
</style>
